import React, { useEffect, useState } from 'react';
import ImagesLightbox from '@app/common/ImagesLightbox';
import cn from 'classnames';
import styles from './index.module.less';
import { Rate } from '@base/lib/Rate';
import type { IFeatureSwiperReviews } from 'mod/feature/interface';
import { getProductSpu } from '@base/product/services';
import type { IVariant } from 'base/interfaces/product';
import Image from '@base/lib/ThemeImage';
import { getMainPicUrl } from 'base/utils/getPicUrl';
import Link from '@base/lib/ThemeLink';
import { stringReplaceMiddleChars } from 'base/utils/string'

type IProps = {
    reviewItem?: IFeatureSwiperReviews['lists'][number]
}

const ReviewDetail: React.FC<IProps> = (props) => {
    const { reviewItem } = props

    const [variant, setVariant] = useState<IVariant>()

    const { variantId } = reviewItem || {}

    const getSpu = async () => {
        try {
            const spu = await getProductSpu({ variantId })
            const _variant = spu.productVariants?.find((variant: IVariant) => {
                return variant.productVariantId === variantId
            })
            setVariant(_variant)
        } catch (e) {
        } finally {
        }
    }

    useEffect(() => {
        setVariant(void 0)
        if (!!variantId) {
            getSpu().then()
        }

    }, [variantId])
    
    return (
        <div className={styles.container}>
            <div className={cn(styles['grid-top'], 'flex')}>
                <div className={cn(styles['grid-top-left'])}>
                    <ImagesLightbox aspectRatio={1.3333} imagesList={reviewItem?.images || []}/>
                </div>

                <div className={cn(styles['grid-top-right'], 'flex-1 flex flex-vertical flex-justify')}>
                    <div className={cn(styles.info, 'flex-1')}>
                        <div className={cn(styles['name-rate'], 'flex flex-justify')}>
                            <span className={styles['user-name']}>{stringReplaceMiddleChars(reviewItem?.userName|| '')}</span>
                            <Rate value={reviewItem?.rate} starSize={15}/>
                        </div>

                        <p className={styles.title}>{reviewItem?.title}</p>
                        <p className={styles.content}>{reviewItem?.content}</p>
                    </div>

                    {/* 变体 链接*/}
                    {(!!variant && !!variant.isOnSale) && (
                        <div className={styles['variant-wrap']}>
                            <p className={styles['title']}>
                                Purchased item
                            </p>

                            <Link href={variant.url}>
                                <a target={'_blank'}>
                                    <div className={'flex'}>
                                        <div className={styles['image']}>
                                            <Image
                                                src={getMainPicUrl(variant.pics)}
                                                width={117}
                                                fixed
                                            />
                                        </div>
                                        <div className={styles.detail}>
                                            <p className={styles.name}>{variant.name}</p>
                                            <p className={styles.price}>{variant.dealPriceExchangeDisplay || variant.shopPriceExchangeDisplay}</p>
                                        </div>
                                    </div>
                                </a>
                            </Link>
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
};

export default ReviewDetail